const delay = ms => new Promise(r => setTimeout(r, ms));
const $   = id => document.getElementById(id);
const add = (el, cls) => el && el.classList.add(cls);
const rm  = (el, cls) => el && el.classList.remove(cls);
const $storyOpening = document.querySelector('.story-opening');
const $storyDetail = document.querySelector('.story-detail');
const $replay = document.querySelector('#replay');
const yearLength = storyOpeningTiming.length + 1;

async function opening() {
  add($('photo-mask'), 'visible');
  await delay(200);

  add($('p1'), 'visible');
  await delay(100);

  add($('opening-text'), 'visible');

  await delay(3200);

  rm($('opening-text'), 'visible');
  await delay(400);
  rm($('p1'), 'visible');
  await delay(200);
}

async function flashback() {

  for (let i = 0; i < storyOpeningTiming.length; i++) {
    const idx = i + 2;
    const photo = $(`p${idx}`);
    const year  = $(`y${idx}`);
    const [displayMs, outMs] = storyOpeningTiming[i];

    add(photo, 'visible');
    add(year, 'in');
    await delay(displayMs);

    rm(year, 'in');
    add(year, 'out');
    rm(photo, 'visible');
    await delay(outMs + 40);
  }

  rm($('photo-mask'), 'visible');
  await delay(150);
}

async function phase3() {
  $storyOpening.classList.add('is-hidden');
  $storyDetail.classList.add('is-active');
  $replay.classList.add('is-active');
}

function resetAll() {
  for (let i = 1; i <= yearLength; i++) {
    rm($(`p${i}`), 'visible');
  }
  for (let i = 2; i <= yearLength; i++) {
    rm($(`y${i}`), 'in');
    rm($(`y${i}`), 'out');
  }

  ['photo-mask','opening-text']
    .forEach(id => rm($(id), 'visible'));

  rm(document.querySelector('.logo-catch'), 'visible');
  rm(document.querySelector('.logo-body'), 'visible');
}

async function runAnimation() {
  await opening();
  await flashback();
  await phase3();
}

resetAll();
runAnimation();

$('replay').addEventListener('click', async () => {
  $storyOpening.classList.remove('is-hidden');
  rm($('replay'), 'is-active');
  await delay(300);
  resetAll();
  await delay(100);
  runAnimation();
});